import React from "react";
import styled from "styled-components";

import { isMobile } from "@kubera/common";

import dinosaurImg from "assets/images/dinosaur.png";
import kuberaLogo from "assets/images/kubera_logo.svg";

const isMobileDevice = isMobile();

const Container = styled.div`
  font-family: Inter;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  box-sizing: border-box;
  padding: 0 0.9375rem;
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: -7.5rem;
`;

const ContentImg = styled.img`
  width: 7.5rem;
  margin-bottom: 1.75rem;
`;

const KuberaLogo = styled.img`
  width: 5.625rem;
  margin-bottom: 0.625rem;
`;

const Title = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.5125rem;
  text-align: center;
  margin-bottom: 0.625rem;
`;

const Desc = styled.div`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.625rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 0.5625rem;
`;

const LinksContainer = styled.div`
  display: flex;
  column-gap: 1.5625rem;
`;

const UpdateLinks = styled.a`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.21rem;
  text-align: center;
  color: #000;
`;

function BrowserNotSupported() {
  return (
    <Container>
      <ContentContainer>
        <ContentImg src={dinosaurImg} />
        <KuberaLogo src={kuberaLogo} />
        <Title>Update your Browser</Title>
        <Desc>
          {!isMobileDevice && (
            <>
              Your browser is so old, it remembers when the internet was called 'the information superhighway'.
              <br />
            </>
          )}
          Kubera is not compatible with your current browser version. Please update your browser to the latest version.
        </Desc>
        <LinksContainer>
          <UpdateLinks href="https://support.google.com/chrome/answer/95414" target="_blank" rel="noopener noreferrer">
            Chrome
          </UpdateLinks>
          <UpdateLinks href="https://support.apple.com/en-us/102665" target="_blank" rel="noopener noreferrer">
            Safari
          </UpdateLinks>
          <UpdateLinks
            href="https://support.microsoft.com/en-us/topic/microsoft-edge-update-settings-af8aaca2-1b69-4870-94fe-18822dbb7ef1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Edge
          </UpdateLinks>
          <UpdateLinks
            href="https://support.mozilla.org/en-US/kb/update-firefox-latest-release"
            target="_blank"
            rel="noopener noreferrer"
          >
            Firefox
          </UpdateLinks>
        </LinksContainer>
      </ContentContainer>
    </Container>
  );
}

export default BrowserNotSupported;
